import { Component } from '@angular/core';
import { IconService } from './shared';

@Component({
  selector: 'flow-sync-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public title: string = 'flow-sync';

  constructor(private iconService: IconService) {
    // no need to call anything — just injecting triggers registration
  }
}
